import { createStyles, keyframes } from '@mantine/core';

import themeVariables from '@/styles/themeVariables';

const blinkEffect = keyframes({
  '50%': { opacity: 0 },
});

export const useLatestNewsPageStyle = createStyles((theme) => ({
  newsPageContainer: {
    [theme.fn.largerThan('sm')]: {
      padding: 12,
    },
  },

  newsPageHeader: {
    display: 'flex',
    gap: 20,
    alignItems: 'end',
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 6,
    },
  },

  newsPageCardDivider: {
    margin: '30px 0px',
    [theme.fn.smallerThan('sm')]: {
      margin: '10px 0px 5px',
    },
  },

  navigatedDarkCard: {
    backgroundColor: themeVariables.colors.darkHover,
    borderRadius: '16px',
    padding: '12px 6px',
    animation: `${blinkEffect} 1s ease-in-out`,
    animationIterationCount: 1,
    animationDelay: '0.1s',
  },

  navigatedCard: {
    backgroundColor: themeVariables.colors.light000,
    border: `1px solid ${themeVariables.colors.light100}`,
    borderRadius: '16px',
    padding: '12px 6px',
    animation: `${blinkEffect} 1s ease-in-out`,
    animationIterationCount: 1,
    animationDelay: '0.1s',
  },

  newsCardContainer: {
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },

  publishedText: {
    fontSize: 12,
    fontWeight: 400,
    padding: 2,
    width: 66,
  },

  newsTextContainer: {
    gap: 12,
    width: '100%',
    [theme.fn.largerThan('sm')]: {
      paddingRight: 12,
    },
  },

  newsCardText: {
    overflow: 'hidden',
    lineHeight: 2,
    [theme.fn.largerThan('sm')]: {
      textAlign: 'justify',
    },
  },

  expandText: {
    color: themeVariables.fontColors.extraLight,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },

  slackButtonContainer: {
    position: 'fixed',
    top: 120,
    cursor: 'pointer',
    padding: '8px 12px',
    borderRadius: '16px',
    backgroundColor: themeVariables.colors.white,
    boxShadow: themeVariables.boxShadow.popOverShadow,
    border: `1px solid ${themeVariables.colors.light300}`,
    transition: '300ms all ease',
    '&:active': {
      transform: 'scale(0.95)',
    },
  },
}));
